import { computed, reactive } from '@nuxtjs/composition-api';
import { StateInterface, UseTemporizedCartInterface } from '~/composables/useTemporizedCart/useTemporizedCart';
const state = reactive<StateInterface>({
  deletedProducts: []
});

/**
 * Global store for managing UI state.
 *
 * See the {@link UseUiStateInterface} for a list of methods and values available in this composable.
 */
export function useTemporizedCart(): UseTemporizedCartInterface {

  const addDeletedProduct = product => {
    state.deletedProducts.push(product)
  }
  const removeDeletedProduct = product => {
    const index = state.deletedProducts.map(el => el.uid).indexOf(product.uid)
    state.deletedProducts.splice(index, 1)
  }

  return {
    deletedProducts: computed(() => state.deletedProducts),
    addDeletedProduct,
    removeDeletedProduct
    
  };
}

export default useTemporizedCart;
export * from './useTemporizedCart';